export async function withMaxConcurrency<T>(taskRunners: (() => Promise<T>)[], maxConcurrency: number = 10): Promise<T[]> {
    const results: T[] = [];
    let firstError: unknown = null;
    let hasFailed = false;

    //A promise chain that runs the tasks from the queue one after the other until the queue is empty
    const runTask = async () => {
        // Once a task has failed the remaining queued tasks are left untouched, otherwise the other
        // chains would keep running work after the caller has already received the rejection
        if (hasFailed) {
            return;
        }

        const taskRunner = taskRunners.shift();
        if (!taskRunner) {
            return;
        }

        try {
            const result = await taskRunner();
            results.push(result);
        } catch (err) {
            if (!hasFailed) {
                hasFailed = true;
                firstError = err;
            }
            return;
        }

        return runTask();
    };

    // Waiting for all chains to finish so no task is still running when the caller gets the result
    await Promise.all([...new Array(Math.min(maxConcurrency, taskRunners.length))].map(runTask));

    if (hasFailed) {
        throw firstError;
    }

    return results;
}
